/**
 * Created by PanJiaChen on 16/11/18.
 */

import { parse } from 'csv-parse'
import moment from 'moment'
import store from '@/store'
import SparkMD5 from 'spark-md5'
import AppInfoParser from 'app-info-parser'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}
/**
 * 判断变量是否为空
 * 空数组、空字符串、false、undefined、null、空对象、0 会返回false
 * @param variable
 * @returns {boolean}
 */
export function empty(variable) {
  if (Array.isArray(variable)) {
    return variable.length === 0
  }
  let varType = typeof variable
  if (varType === 'string') {
    return variable === ''
  } else if (varType === 'boolean') {
    return !variable
  } else if (varType === 'undefined') {
    return true
  } else if (varType === 'number') {
    return variable === 0
  }
  varType = Object.prototype.toString.call(variable)
  if (varType === '[object Null]') {
    return true
  } else if (varType === '[object Object]') {
    return Object.keys(variable).length === 0
  }
}

export function today() {
  return moment().format('Y-MM-DD')
}
export function now() {
  return moment().format('Y-MM-DD HH:mm:ss')
}
export function nowMinute() {
  return moment().format('HH:mm')
}

export function nextMouth() {
  return moment().add(1, 'month').format('Y-MM-DD')
}

/**
 * ISO8601格式的duration转成人可读的
 * @param duration
 * @returns {string}
 */
export function dateDurationHumanize(duration) {
  const mo = moment.duration(duration)
  const hour = mo.hours()
  let durationHuman = leadingZero(mo.minutes()) + ':' + leadingZero(mo.seconds())
  if (hour) {
    durationHuman = leadingZero(hour) + ':' + durationHuman
  }
  return durationHuman
}

/**
 * 前导0
 * @param num
 * @returns {string}
 */
export function leadingZero(num) {
  if (num.toString().length < 2) {
    num = '0' + num
  }
  return num
}

// 查询时默认的operator
export const operatorSeparator = ''

/**
 * 是否是开发环境
 * @returns {boolean}
 */
export function isDevelopEnv() {
  return process.env.NODE_ENV === 'development'
}

/**
 * 解析csv
 * @param file
 * @param withKey
 * @returns {Promise<unknown>}
 */
export function parseCsv(file, listMap, withKey = false) {
  const reader = new FileReader()
  reader.readAsText(file, 'utf-8')
  reader.onerror = () => {
    throw new Error('讀取文件時發生錯誤')
  }
  return new Promise((resolve, reject) => {
    reader.onload = () => {
      parse(reader.result, (error, list) => {
        if (error) {
          reject(error)
          return
        }
        if (withKey) {
          list.shift()
          list.forEach((item, index) => {
            list[index] = listMap(item, index)
          })
        }
        resolve(list)
      })
    }
  })
}

/**
 * 获取文件的md5
 * @param file
 */
export function getFileMd5(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()

    fileReader.onload = () => {
      const arrayBuffer = fileReader.result
      const md5Hash = SparkMD5.ArrayBuffer.hash(arrayBuffer)
      resolve(md5Hash)
    }

    fileReader.onerror = (error) => {
      reject(error)
    }

    fileReader.readAsArrayBuffer(file)
  })
}

/**
 * 检测"原生原影"格式是否有误(简单处理)
 * @param zipFile
 */
export async function checkSong(zipFile) {
  const jszip = new JSZip()

  await jszip.loadAsync(zipFile).then((zip) => {
    zip.forEach((path, file) => {
      if (!file.dir && !file.name.startsWith('.') && !file.name.startsWith('__MACOSX')) {
        const fileExtension = file.name.split('.').pop()
        const fileName = file.name.replace(/\.[^.]+$/, '')

        if (['mi6', 'mi6d', 'mu6', 'mu6d', 'vh5', 'vk6', 'li6', 'vs6', 'cps'].includes(fileExtension)) {
          if (fileExtension === 'cps') {
            const isAscii = /^[\x00-\x7F]*$/.test(fileName)
            if (!isAscii) {
              throw new Error('不是ascii字符串')
            }
          } else {
            if (isNaN(Number(fileName))) {
              throw new Error('歌號不對')
            }
          }
        }
      }
    })
  })
}

/**
 * 检测"音圆歌集"格式是否有误(简单处理)
 * @param zipFile
 */
export async function checkMidi(zipFile) {
  const jszip = new JSZip()

  await jszip.loadAsync(zipFile).then((zip) => {
    zip.forEach((path, file) => {
      if (!file.dir && !file.name.startsWith('.') && !file.name.startsWith('__MACOSX')) {
        const fileExtension = file.name.split('.').pop()
        const fileName = file.name.replace(/\.[^.]+$/, '')
        if (['mi6', 'mi6d', 'mu6', 'mu6d', 'vs6', 'vk6', 'ck6', 'li6', 'cps'].includes(fileExtension)) {
          if (fileExtension === 'cps') {
            const isAscii = /^[\x00-\x7F]*$/.test(fileName)
            if (!isAscii) {
              throw new Error('不是ascii字符串')
            }
          } else {
            if (isNaN(Number(fileName))) {
              throw new Error('歌號不對')
            }
          }
        }
      }
    })
  })
}

/**
 * 将文件压缩为 ZIP
 * @param {File} file - 原始文件
 * @param {Object} options - 压缩选项
 * @returns {Promise<File>}
 */
export async function compressFileToZip(file, options = {}) {
  const {
    fileName = file.name, // ZIP 中的文件名
    zipName = file.name.replace(/\.[^/.]+$/, '') + '.zip', // ZIP 文件名
    compressionLevel = 9 // 压缩级别 1-9
  } = options

  try {
    const zip = new JSZip()

    // 读取文件内容
    const fileBuffer = await file.arrayBuffer()

    // 将文件添加到 ZIP 中
    zip.file(fileName, fileBuffer)

    // 生成 ZIP 文件
    const zipBlob = await zip.generateAsync({
      type: 'blob',
      compression: 'DEFLATE',
      compressionOptions: {
        level: compressionLevel
      }
    })

    // 创建新的 File 对象
    const zipFile = new File(
      [zipBlob],
      zipName,
      { type: 'application/zip' }
    )

    return zipFile
  } catch (e) {
    throw new Error('文件压缩失败：' + (e && e.message ? e.message : '未知错误'))
  }
}

/**
 * 批量压缩文件为单个 ZIP
 * @param {File[]} files - 文件数组
 * @param {string} zipName - ZIP 文件名
 * @returns {Promise<File>}
 */
export async function compressFilesToZip(files, zipName = 'archive.zip') {
  try {
    const zip = new JSZip()

    // 添加所有文件到 ZIP
    for (const file of files) {
      const fileBuffer = await file.arrayBuffer()
      zip.file(file.name, fileBuffer)
    }

    // 生成 ZIP 文件
    const zipBlob = await zip.generateAsync({
      type: 'blob',
      compression: 'DEFLATE',
      compressionOptions: {
        level: 9
      }
    })

    const zipFile = new File(
      [zipBlob],
      zipName,
      { type: 'application/zip' }
    )

    return zipFile
  } catch (e) {
    throw new Error('文件压缩失败：' + (e && e.message ? e.message : '未知错误'))
  }
}

const APK_FILE_NAME_PATTERN = /^(.+?\.apk)(?:(?:\.\d+)|(?:\.apk)|(?:_tmp))*$/i

/**
 * 标准化微信转发后产生的 APK 文件名。
 * 例如 app.apk.1.apk.1_tmp 会还原为 app.apk。
 */
export function normalizeApkFileName(fileName) {
  if (typeof fileName !== 'string') {
    return ''
  }

  const match = fileName.match(APK_FILE_NAME_PATTERN)
  return match ? match[1].replace(/\.apk$/i, '.apk') : ''
}

export function isApkFileName(fileName) {
  return normalizeApkFileName(fileName) !== ''
}

export async function parseApk(apkSource) {
  let parserSource = apkSource

  if (typeof window !== 'undefined' && apkSource && apkSource.name) {
    const normalizedName = normalizeApkFileName(apkSource.name)
    if (!normalizedName) {
      throw new Error('请选择 APK 文件')
    }

    // app-info-parser 通过最后一个扩展名判断类型，需要先恢复标准 .apk 文件名。
    if (normalizedName !== apkSource.name) {
      parserSource = new File([apkSource], normalizedName, {
        type: apkSource.type,
        lastModified: apkSource.lastModified
      })
    }
  }

  try {
    const parser = new AppInfoParser(parserSource)
    const res = await parser.parse()

    // 兼容不同库版本的字段命名
    const packageName =
      res.package ||
      res.packageName ||
      (res.manifest && res.manifest.package) ||
      ''

    const versionName =
      res.versionName ||
      res.version || // 部分版本把 versionName 叫 version
      ''

    const versionCode = res.versionCode

    return {
      package_name: packageName,
      version: versionCode, // 优先返回版本码（number 或 null）
      version_name: versionName // 版本名（string）
    }
  } catch (e) {
    throw new Error('APK 解析失败：' + (e && e.message ? e.message : '未知错误'))
  }
}

/**
 * 检查权限
 * @param perms
 * @returns {boolean}
 */
export function can(perms) {
  if (empty(perms)) {
    return true
  }
  if (!Array.isArray(perms)) {
    return store.state.user.permissions.indexOf(perms) !== -1
  } else {
    const has = perms.some(perm => {
      return store.state.user.permissions.indexOf(perm) !== -1
    })
    return has
  }
}

/**
 * 获取文件后缀名
 * @param path
 * @returns {*|string}
 */
export function getExtName(path) {
  return path.substr(path.lastIndexOf('.') + 1)
}

export function rulesAddRequiredMsg(rules) {
  let target
  for (const key in rules) {
    target = {}
    if (Array.isArray(rules[key])) {
      for (const keyElement of rules[key]) {
        if (keyElement.hasOwnProperty('required')) {
          target = keyElement
        }
      }
    } else {
      if (rules[key].hasOwnProperty('required')) {
        target = rules[key]
      }
    }
    target.message = target.message ?? 'required'
  }
  return rules
}

/**
 *
 * @returns {string}
 */
export function genOssName(dir, extName) {
  if (!extName) {
    extName = dir
  }
  const now = new Date()
  return `${dir}/${now.getFullYear()}/${now.getMonth() + 1}/${now.getTime()}.${extName}`
}

import OSS from 'ali-oss'
import JSZip from 'jszip'
let ossClientPrivate
/**
 * 私有ossClient
 * @returns {Client}
 */
export function getOssClientPrivate() {
  if (!ossClientPrivate) {
    ossClientPrivate = new OSS({
      region: process.env.VUE_APP_OSS_REGION,
      accessKeyId: process.env.VUE_APP_OSS_KEY_ID,
      accessKeySecret: process.env.VUE_APP_OSS_KEY_SECRET,
      bucket: process.env.VUE_APP_OSS_BUCKET,
      secure: true,
      timeout: '300s'
    })
  }
  return ossClientPrivate
}

/**
 * 公有oss的资源
 * @param path
 * @returns {string}
 */
export function publicOss(path) {
  const p = (path ?? '').trim()
  if (!p) return ''

  if (/^https?:\/\//i.test(p)) {
    return p
  }
  return getOssClientPrivate().generateObjectUrl(path)
}

/**
 * youtube视频页地址
 * @param path
 * @returns {string}
 */
export function youtubeVideo(path) {
  return 'https://www.youtube.com/watch?v=' + path
}

/**
 * 私有oss的资源
 * @param path
 * @returns {string}
 */
export function privateOss(path) {
  const p = (path ?? '').trim()
  if (!p) return ''

  if (/^https?:\/\//i.test(p)) {
    return p
  }
  return getOssClientPrivate().signatureUrl(path)
}

/**
 * 从url里面解析出某个query
 * @param url
 * @param queryKey
 * @returns {string}
 */
export function urlGetQuery(url, queryKey) {
  // 判断协议是否为HTTP或HTTPS
  if (!/^https?:\/\//i.test(url)) {
    return -1
  }
  const urlObj = new URL(url)
  const urlParamObj = new URLSearchParams(urlObj.search)
  return urlParamObj.get(queryKey)
}

export function isValidYtVideoPlayUrl(url) {
  // 判断协议是否为HTTPS
  if (!/^https:\/\//i.test(url)) {
    return false
  }
  if (url.includes('youtube.com/watch') || url.includes('youtu.be')) {
    return true
  }
  return false
}
